import { render, staticRenderFns } from "./pageMain.vue?vue&type=template&id=ecf2435c&"
import script from "./pageMain.vue?vue&type=script&lang=js&"
export * from "./pageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports